import React from 'react';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import Select from '../../../../components/input/Select';
import Input from '../../../../components/input/Input';
import { addAllItemToSelectList, setQuickToDate, setTrim } from '../../../../lib/common';
import ButtonList from '../../../../components/ButtonList';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import {
  VERSION_FORCE_UPDATE_SELECT_LIST,
  VERSION_PERIOD_SEARCH_TYPE_SELECT_LIST,
  VERSION_SEARCH_PERIOD_BUTTON_LIST,
  VERSION_TYPE_SELECT_LIST,
} from '../../../../constants/service/app/versionConstants';
import {
  VERSION_LIST_SEARCH_OPTION_MODEL,
  VERSION_LIST_SORT_OPTION_MODEL,
} from '../../../../store/modules/version/model';
import { _LIST_PAGINATION_MODEL, LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  DATE_FORMAT,
  QUICK_DATE_SELECT_BUTTON_TARGET,
  SEARCH_PERIOD_BUTTON_ALL_TYPE,
} from '../../../../constants/service/common/utilConstants';
import './VersionListSearchBox.scss';

const VersionListSearchBox = (props) => {
  const { getList, searchData, setData } = props;
  const { type, serviceVer, code, forceUpdate, viewPeriod } = searchData;

  return (
    <SearchBox
      className="version-list-search-box"
      onSearch={() => {
        getList({
          searchOption: {
            type,
            forceUpdate,
            serviceVer,
            code,
            viewPeriod: {
              type: viewPeriod.type,
              quickDateIndex: viewPeriod.quickDateIndex,
              period: viewPeriod.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? viewPeriod.period : null,
            },
          },
          /**
           *  리스트 pagination
           */
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          /**
           *  검색 박스
           */
          searchData: VERSION_LIST_SEARCH_OPTION_MODEL,
          /**
           *  검색 옵션
           */
          searchOption: VERSION_LIST_SEARCH_OPTION_MODEL,
          /**
           *  정렬 옵션
           */
          sortOption: VERSION_LIST_SORT_OPTION_MODEL,
          /**
           *  리스트 pagination
           */
          pagination: LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: VERSION_LIST_SEARCH_OPTION_MODEL,
        });
      }}
    >
      <BaseForm
        label="타입"
        content={
          <Select
            className="select-search-option"
            value={type}
            list={addAllItemToSelectList(VERSION_TYPE_SELECT_LIST)}
            onChange={(value) => {
              setData({
                path: ['type'],
                value,
              });
            }}
          />
        }
      />

      <BaseForm
        label="서비스 버전"
        content={
          <Input
            className="select-search-option"
            value={serviceVer}
            onChange={(value) =>
              setData({
                path: ['serviceVer'],
                value: setTrim(value),
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                sortOption: VERSION_LIST_SORT_OPTION_MODEL,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            size="large"
          />
        }
      />

      <BaseForm
        label="버전 코드"
        content={
          <Input
            className="select-search-option"
            value={code}
            onChange={(value) =>
              setData({
                path: ['code'],
                value: setTrim(value),
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                sortOption: VERSION_LIST_SORT_OPTION_MODEL,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            size="large"
          />
        }
      />

      <BaseForm
        label="강제 업데이트 여부"
        content={
          <Select
            className="select-search-option"
            value={forceUpdate}
            list={addAllItemToSelectList(VERSION_FORCE_UPDATE_SELECT_LIST)}
            onChange={(value) => {
              setData({
                path: ['forceUpdate'],
                value,
              });
            }}
          />
        }
      />

      <BaseForm
        label={
          <Select
            list={VERSION_PERIOD_SEARCH_TYPE_SELECT_LIST}
            onChange={(id) =>
              setData({
                path: ['viewPeriod', 'type'],
                value: id,
              })
            }
            value={viewPeriod.type}
            isTable={true}
          />
        }
        content={
          <div className="quick-date-picker">
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={viewPeriod.quickDateIndex}
              list={VERSION_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setData({
                  path: ['viewPeriod'],
                  value: setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: viewPeriod.period,
                    type: viewPeriod.type,
                  }),
                })
              }
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={viewPeriod.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) =>
                setData({
                  path: ['viewPeriod'],
                  value: setQuickToDate({
                    period,
                    type: viewPeriod.type,
                  }),
                })
              }
            />
          </div>
        }
      />
    </SearchBox>
  );
};

export default VersionListSearchBox;
